<template>
  <div class="relatorio-os">
    <box :title="t(TITULOS[tipo])">
      <div v-if="erro" class="ros-aviso">{{ erro }}</div>

      <div v-else-if="!carregando && linhas.length === 0" class="ros-aviso" data-testid="relatorio-os-vazio">
        {{ t('Nenhuma OS quitada no período e nas franquias do filtro.') }}
      </div>

      <template v-else-if="linhas.length > 0">
        <p class="ros-nota">{{ t(NOTAS[tipo]) }}</p>
        <p v-if="tipo === 'consumo'" class="ros-resumo" data-testid="relatorio-os-consumo-resumo">
          {{ t('Clientes recorrentes (2 OS ou mais)') }}: {{ recorrentes.quantos }} {{ t('de') }} {{ recorrentes.total }}
          ({{ n(recorrentes.fracao, 'percent') }})
          <InfoTip :explanation="EX.consumo.recorrentes" :label="t('Clientes recorrentes')" test-id="relatorio-os-recorrentes-info" />
        </p>
        <RelatorioOSTable :tipo="tipo" :linhas="linhas" />
      </template>
    </box>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../eventBus';
import { useRelatoriosOS, type TipoRelatorioOS } from '../../composables/useRelatoriosOS';
import { osReportExplanations } from './explanations';

const props = defineProps<{ tipo: TipoRelatorioOS }>();

const { t, n } = useI18n();
const { linhas, carregando, erro, carregar } = useRelatoriosOS(props.tipo);

const TITULOS: Record<TipoRelatorioOS, string> = {
  clientes: 'Vendas por cliente',
  servicos: 'Vendas por serviço',
  produtividade: 'Produtividade por usuário',
  consumo: 'Consumo por cliente',
};
const NOTAS: Record<TipoRelatorioOS, string> = {
  clientes: 'Conta só as OS quitadas, abertas no período. O total já tem o desconto da OS.',
  servicos: 'Conta só as OS quitadas, abertas no período. O valor é o dos itens, antes do desconto da OS.',
  produtividade: 'OS quitadas que o usuário abriu no período e etapas de produção que ele concluiu no período.',
  consumo: 'Conta só as OS quitadas com serviço, abertas no período. O valor é o dos serviços, adicionais e combos, antes do desconto da OS.',
};

const EX = computed(() => osReportExplanations(t));

/** Clientes com 2 OS ou mais, sobre todos os da lista. */
const recorrentes = computed(() => {
  const total = linhas.value.length;
  const quantos = linhas.value.filter((l) => Number((l as { ordens?: number }).ordens) >= 2).length;
  return { quantos, total, fracao: total > 0 ? quantos / total : 0 };
});

function recarrega(): void {
  void carregar();
}

onMounted(() => {
  void carregar();
  eventBus.on('filter.updated', recarrega);
});

onBeforeUnmount(() => {
  eventBus.off('filter.updated', recarrega);
});

defineExpose({ loadData: carregar });
</script>

<style scoped>
.ros-nota {
  margin: 0 0 0.75rem;
  font-size: 0.85rem;
  opacity: 0.75;
}

.ros-resumo {
  margin: 0 0 0.75rem;
  font-weight: 600;
}

.ros-aviso {
  padding: 1rem;
}
</style>
